module.exports = __webpack_public_path__ + "static/media/rukaiya.83fe9dcf.jpg";